export default "/images/discount.svg?bd05954fa411283c26052db86bdbe1b0";